import script from "./CategoriesIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoriesIndex.vue?vue&type=script&lang=ts&setup=true"

import "./CategoriesIndex.vue?vue&type=style&index=0&id=8670c780&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8670c780"]])

export default __exports__